import {Typography, Divider, Box} from "@mui/material";


const PageTitle = ({title}: { title: string }) => {
    return (
        <>
            <Box>
                <Typography variant="h4">{title}</Typography>
            </Box>
            <Divider sx={{color: "#303030"}} />
        </>
    )
}

export default PageTitle;